import React from 'react';
import logo from './logo.png';

export const Logo = () => <img src={logo} alt="Logotype" className="Logo" />